// extracted by mini-css-extract-plugin
export default {"main":"GeneratorsPage_main__zJI4k","whyUsText":"GeneratorsPage_whyUsText__oACFB","headerPr":"GeneratorsPage_headerPr__AqCAp","whyUs":"GeneratorsPage_whyUs__Nm1Ft"};